module.exports = __webpack_public_path__ + "static/img/procedures.534a5b5a.png";